// extracted by mini-css-extract-plugin
export default {"results":"ImagesPage_results__GyRsG"};